export default function TestimonialSection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1200px] mx-auto text-center">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
          (Depoimentos de Usuários)
        </h2>
        <p className="text-foreground-500 text-base mb-12">
          O que nossa comunidade diz sobre o CSSBuy Spreadsheet
        </p>

        <div className="max-w-2xl mx-auto">
          {/* Stars */}
          <div className="inline-flex items-center gap-1 px-4 py-2 rounded-full bg-accent-100 text-accent-700 mb-6">
            <i className="ri-star-fill text-base"></i>
            <i className="ri-star-fill text-base"></i>
            <i className="ri-star-fill text-base"></i>
            <i className="ri-star-fill text-base"></i>
            <i className="ri-star-half-fill text-base"></i>
            <span className="ml-2 font-bold text-sm">4.9</span>
          </div>

          {/* Quote */}
          <blockquote className="mb-8">
            <p className="font-heading text-xl md:text-2xl text-foreground-800 italic leading-relaxed">
              "A planilha CSSBuy mudou completamente minha experiência de compras da China. Antes eu perdia horas procurando produtos, agora encontro tudo organizado por categorias com preços atualizados. Recomendo para todo mundo que quer economizar tempo e dinheiro!"
            </p>
          </blockquote>

          {/* User */}
          <div className="flex items-center justify-center gap-3">
            <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
              <img
                src="https://readdy.ai/api/search-image?query=Friendly%20young%20professional%20portrait%20on%20warm%20neutral%20studio%20background%2C%20genuine%20smile%2C%20casual%20style%2C%20clean%20headshot%20photography%2C%20soft%20natural%20lighting%2C%20approachable%20vibe&width=100&height=100&seq=avatar-v3&orientation=squarish"
                alt="Usuário CSSBuy Spreadsheet"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="text-left">
              <p className="font-semibold text-foreground-950 text-sm">João Silva</p>
              <p className="text-foreground-400 text-xs">Comprador desde 2023</p>
            </div>
          </div>

          {/* Nav arrows */}
          <div className="flex items-center justify-center gap-3 mt-10">
            <button className="w-10 h-10 flex items-center justify-center rounded-full border-2 border-foreground-300 text-foreground-600 cursor-pointer hover:border-foreground-500 transition-colors">
              <i className="ri-arrow-left-s-line text-lg"></i>
            </button>
            <button className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 text-background-50 cursor-pointer hover:bg-primary-600 transition-colors">
              <i className="ri-arrow-right-s-line text-lg"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}